export const appendCounter = (locaizedString: string, amount: number) => `${locaizedString} (${amount})`;
export const removeWhiteSpace = (str: string) => str.replace(/\s/g, '');
